import { type ReactNode } from 'react';
import { buttonVariants } from '@paypoteam/ui-components/Button';
import type { DOMNode, HTMLReactParserOptions } from 'html-react-parser';
import parse, { domToReact, Element } from 'html-react-parser';

import { cn } from '@/lib/utils';

// use client side only
export const parseHtmlWithStyledLinks = (html: string): ReactNode => {
    let paragraphCounter = 0;
    const options: HTMLReactParserOptions = {
        replace: domNode => {
            if (domNode instanceof Element && domNode.name === 'a') {
                const text = domNode.children
                    .map(child => {
                        if ('data' in child) {
                            return child.data;
                        }
                        return '';
                    })
                    .join('');

                const target = domNode.attribs.target;
                return (
                    <a
                        href={domNode.attribs.href}
                        target={target || undefined}
                        rel={
                            target === '_blank'
                                ? 'noopener noreferrer'
                                : undefined
                        }
                        className={cn(
                            buttonVariants({
                                variant: 'ghost',
                            }),
                            'inline justify-start font-primary font-normal',
                            domNode.attribs.class && domNode.attribs.class,
                        )}
                    >
                        {text}
                    </a>
                );
            }
            if (domNode instanceof Element && domNode.name === 'p') {
                const hasContent = domNode.children.some(child =>
                    'data' in child
                        ? child.data.trim().length > 0
                        : child instanceof Element,
                );
                if (!hasContent) return <></>;

                const isFirst = paragraphCounter === 0;
                paragraphCounter++;

                const className = cn(
                    !isFirst && 'mt-4',
                    domNode.attribs.class,
                );

                return (
                    <p {...(className ? { className } : {})}>
                        {domToReact(domNode.children as DOMNode[], options)}
                    </p>
                );
            }
        },
    };

    return parse(html || '', options);
};
